import React from 'react';
import styled from 'styled-components';

import Checkbox from 'shared/components/Checkbox';

import { SelectableOptionProps } from './types';

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledCheckbox = styled(Checkbox)`
  margin-right: 1rem;
`;

const StyledLabel = styled.span`
  font-weight: 700;
`;

const SelectableOption = ({
  option,
  isSelected,
}: SelectableOptionProps) => (
  <StyledContainer>
    <StyledCheckbox isChecked={isSelected} />
    <StyledLabel>{option.label || option.name}</StyledLabel>
  </StyledContainer>
);

export default SelectableOption;
